import {
    TOURNAMENT_LIST_REQUEST, TOURNAMENT_LIST_SUCCESS, TOURNAMENT_LIST_FAIL,
    TOURNAMENT_DETAILS_REQUEST, TOURNAMENT_DETAILS_SUCCESS, TOURNAMENT_DETAILS_FAIL, TOURNAMENT_DETAILS_RESET,
    TOURNAMENT_CREATE_REQUEST, TOURNAMENT_CREATE_SUCCESS, TOURNAMENT_CREATE_FAIL, TOURNAMENT_CREATE_RESET,
    TOURNAMENT_UPDATE_REQUEST, TOURNAMENT_UPDATE_SUCCESS, TOURNAMENT_UPDATE_FAIL, TOURNAMENT_UPDATE_RESET,
    TOURNAMENT_DELETE_REQUEST, TOURNAMENT_DELETE_SUCCESS, TOURNAMENT_DELETE_FAIL,
    TOURNAMENT_DAY_CREATE_REQUEST, TOURNAMENT_DAY_CREATE_SUCCESS, TOURNAMENT_DAY_CREATE_FAIL, TOURNAMENT_DAY_CREATE_RESET,
    TOURNAMENT_DAY_UPDATE_REQUEST, TOURNAMENT_DAY_UPDATE_SUCCESS, TOURNAMENT_DAY_UPDATE_FAIL, TOURNAMENT_DAY_UPDATE_RESET,
    TOURNAMENT_DAY_DELETE_REQUEST, TOURNAMENT_DAY_DELETE_SUCCESS, TOURNAMENT_DAY_DELETE_FAIL,
    TOURNAMENT_AWARD_CREATE_REQUEST, TOURNAMENT_AWARD_CREATE_SUCCESS, TOURNAMENT_AWARD_CREATE_FAIL, TOURNAMENT_AWARD_CREATE_RESET,
    TOURNAMENT_AWARD_DELETE_REQUEST, TOURNAMENT_AWARD_DELETE_SUCCESS, TOURNAMENT_AWARD_DELETE_FAIL,
    TOURNAMENT_CONTEST_CREATE_REQUEST, TOURNAMENT_CONTEST_CREATE_SUCCESS, TOURNAMENT_CONTEST_CREATE_FAIL, TOURNAMENT_CONTEST_CREATE_RESET,
    TOURNAMENT_CONTEST_DELETE_REQUEST, TOURNAMENT_CONTEST_DELETE_SUCCESS, TOURNAMENT_CONTEST_DELETE_FAIL,
    TOURNAMENT_REG_LIST_REQUEST, TOURNAMENT_REG_LIST_SUCCESS, TOURNAMENT_REG_LIST_FAIL,
    TOURNAMENT_REG_ADD_REQUEST, TOURNAMENT_REG_ADD_SUCCESS, TOURNAMENT_REG_ADD_FAIL, TOURNAMENT_REG_ADD_RESET,
    TOURNAMENT_REG_UPDATE_REQUEST, TOURNAMENT_REG_UPDATE_SUCCESS, TOURNAMENT_REG_UPDATE_FAIL,
    TOURNAMENT_REG_DELETE_REQUEST, TOURNAMENT_REG_DELETE_SUCCESS, TOURNAMENT_REG_DELETE_FAIL,
    TOURNAMENT_TEAMS_LIST_REQUEST, TOURNAMENT_TEAMS_LIST_SUCCESS, TOURNAMENT_TEAMS_LIST_FAIL,
    TOURNAMENT_TEAMS_GENERATE_REQUEST, TOURNAMENT_TEAMS_GENERATE_SUCCESS, TOURNAMENT_TEAMS_GENERATE_FAIL,
    TOURNAMENT_TEAMS_CLEAR_REQUEST, TOURNAMENT_TEAMS_CLEAR_SUCCESS, TOURNAMENT_TEAMS_CLEAR_FAIL,
    TOURNAMENT_TEAM_ADD_REQUEST, TOURNAMENT_TEAM_ADD_SUCCESS, TOURNAMENT_TEAM_ADD_FAIL,
    TOURNAMENT_TEAM_MEMBER_ADD_REQUEST, TOURNAMENT_TEAM_MEMBER_ADD_SUCCESS, TOURNAMENT_TEAM_MEMBER_ADD_FAIL,
    TOURNAMENT_TEAM_MEMBER_REMOVE_REQUEST, TOURNAMENT_TEAM_MEMBER_REMOVE_SUCCESS, TOURNAMENT_TEAM_MEMBER_REMOVE_FAIL,
    TOURNAMENT_AWARD_UPDATE_REQUEST, TOURNAMENT_AWARD_UPDATE_SUCCESS, TOURNAMENT_AWARD_UPDATE_FAIL,
    TOURNAMENT_CONTEST_UPDATE_REQUEST, TOURNAMENT_CONTEST_UPDATE_SUCCESS, TOURNAMENT_CONTEST_UPDATE_FAIL,
    TOURNAMENT_WINNER_UPDATE_REQUEST, TOURNAMENT_WINNER_UPDATE_SUCCESS, TOURNAMENT_WINNER_UPDATE_FAIL,
} from '../constants/tournamentConstants'

export const tournamentListReducer = (state = { tournaments: [] }, action) => {
    switch (action.type) {
        case TOURNAMENT_LIST_REQUEST: return { loading: true, tournaments: [] }
        case TOURNAMENT_LIST_SUCCESS: return { loading: false, tournaments: action.payload }
        case TOURNAMENT_LIST_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentDetailsReducer = (state = { tournament: {} }, action) => {
    switch (action.type) {
        case TOURNAMENT_DETAILS_REQUEST: return { loading: true, tournament: {} }
        case TOURNAMENT_DETAILS_SUCCESS: return { loading: false, tournament: action.payload }
        case TOURNAMENT_DETAILS_FAIL:    return { loading: false, error: action.payload }
        case TOURNAMENT_DETAILS_RESET:   return { tournament: {} }
        default: return state
    }
}

export const tournamentCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_CREATE_REQUEST: return { loading: true }
        case TOURNAMENT_CREATE_SUCCESS: return { loading: false, success: true, tournament: action.payload }
        case TOURNAMENT_CREATE_FAIL:    return { loading: false, error: action.payload }
        case TOURNAMENT_CREATE_RESET:   return {}
        default: return state
    }
}

export const tournamentUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_UPDATE_REQUEST: return { loading: true }
        case TOURNAMENT_UPDATE_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_UPDATE_FAIL:    return { loading: false, error: action.payload }
        case TOURNAMENT_UPDATE_RESET:   return {}
        default: return state
    }
}

export const tournamentDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_DELETE_REQUEST: return { loading: true }
        case TOURNAMENT_DELETE_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_DELETE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentDayCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_DAY_CREATE_REQUEST: return { loading: true }
        case TOURNAMENT_DAY_CREATE_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_DAY_CREATE_FAIL:    return { loading: false, error: action.payload }
        case TOURNAMENT_DAY_CREATE_RESET:   return {}
        default: return state
    }
}

export const tournamentDayUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_DAY_UPDATE_REQUEST: return { loading: true }
        case TOURNAMENT_DAY_UPDATE_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_DAY_UPDATE_FAIL:    return { loading: false, error: action.payload }
        case TOURNAMENT_DAY_UPDATE_RESET:   return {}
        default: return state
    }
}

export const tournamentDayDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_DAY_DELETE_REQUEST: return { loading: true }
        case TOURNAMENT_DAY_DELETE_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_DAY_DELETE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentAwardCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_AWARD_CREATE_REQUEST: return { loading: true }
        case TOURNAMENT_AWARD_CREATE_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_AWARD_CREATE_FAIL:    return { loading: false, error: action.payload }
        case TOURNAMENT_AWARD_CREATE_RESET:   return {}
        default: return state
    }
}

export const tournamentAwardDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_AWARD_DELETE_REQUEST: return { loading: true }
        case TOURNAMENT_AWARD_DELETE_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_AWARD_DELETE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentContestCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_CONTEST_CREATE_REQUEST: return { loading: true }
        case TOURNAMENT_CONTEST_CREATE_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_CONTEST_CREATE_FAIL:    return { loading: false, error: action.payload }
        case TOURNAMENT_CONTEST_CREATE_RESET:   return {}
        default: return state
    }
}

export const tournamentContestDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_CONTEST_DELETE_REQUEST: return { loading: true }
        case TOURNAMENT_CONTEST_DELETE_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_CONTEST_DELETE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentRegListReducer = (state = { registrations: [] }, action) => {
    switch (action.type) {
        case TOURNAMENT_REG_LIST_REQUEST: return { loading: true, registrations: [] }
        case TOURNAMENT_REG_LIST_SUCCESS: return { loading: false, registrations: action.payload }
        case TOURNAMENT_REG_LIST_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentRegAddReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_REG_ADD_REQUEST: return { loading: true }
        case TOURNAMENT_REG_ADD_SUCCESS: return { loading: false, success: true, registration: action.payload }
        case TOURNAMENT_REG_ADD_FAIL:    return { loading: false, error: action.payload }
        case TOURNAMENT_REG_ADD_RESET:   return {}
        default: return state
    }
}

export const tournamentRegUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_REG_UPDATE_REQUEST: return { loading: true }
        case TOURNAMENT_REG_UPDATE_SUCCESS: return { loading: false, success: true, registration: action.payload }
        case TOURNAMENT_REG_UPDATE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentRegDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_REG_DELETE_REQUEST: return { loading: true }
        case TOURNAMENT_REG_DELETE_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_REG_DELETE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentTeamsListReducer = (state = { teams: [] }, action) => {
    switch (action.type) {
        case TOURNAMENT_TEAMS_LIST_REQUEST:    return { loading: true, teams: [] }
        case TOURNAMENT_TEAMS_LIST_SUCCESS:    return { loading: false, teams: action.payload }
        case TOURNAMENT_TEAMS_LIST_FAIL:       return { loading: false, error: action.payload }
        // Optimistic update — replace a single team in the list
        case TOURNAMENT_TEAM_MEMBER_ADD_SUCCESS:
        case TOURNAMENT_TEAM_MEMBER_REMOVE_SUCCESS:
            return {
                ...state,
                teams: state.teams.map(t => t.id === action.payload.id ? action.payload : t),
            }
        default: return state
    }
}

export const tournamentTeamsGenerateReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_TEAMS_GENERATE_REQUEST: return { loading: true }
        case TOURNAMENT_TEAMS_GENERATE_SUCCESS: return { loading: false, success: true, teams: action.payload }
        case TOURNAMENT_TEAMS_GENERATE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentTeamsClearReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_TEAMS_CLEAR_REQUEST: return { loading: true }
        case TOURNAMENT_TEAMS_CLEAR_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_TEAMS_CLEAR_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentTeamAddReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_TEAM_ADD_REQUEST: return { loading: true }
        case TOURNAMENT_TEAM_ADD_SUCCESS: return { loading: false, success: true, team: action.payload }
        case TOURNAMENT_TEAM_ADD_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentTeamMemberAddReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_TEAM_MEMBER_ADD_REQUEST: return { loading: true }
        case TOURNAMENT_TEAM_MEMBER_ADD_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_TEAM_MEMBER_ADD_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentTeamMemberRemoveReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_TEAM_MEMBER_REMOVE_REQUEST: return { loading: true }
        case TOURNAMENT_TEAM_MEMBER_REMOVE_SUCCESS: return { loading: false, success: true }
        case TOURNAMENT_TEAM_MEMBER_REMOVE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentAwardUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_AWARD_UPDATE_REQUEST: return { loading: true }
        case TOURNAMENT_AWARD_UPDATE_SUCCESS: return { loading: false, success: true, award: action.payload }
        case TOURNAMENT_AWARD_UPDATE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentContestUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_CONTEST_UPDATE_REQUEST: return { loading: true }
        case TOURNAMENT_CONTEST_UPDATE_SUCCESS: return { loading: false, success: true, contest: action.payload }
        case TOURNAMENT_CONTEST_UPDATE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const tournamentWinnerUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case TOURNAMENT_WINNER_UPDATE_REQUEST: return { loading: true }
        case TOURNAMENT_WINNER_UPDATE_SUCCESS: return { loading: false, success: true, tournament: action.payload }
        case TOURNAMENT_WINNER_UPDATE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}
